import { z } from 'zod';

import { BorrowerId, LoanNoteId, UserId } from '../BrandedIds';
import { LoanNoteContactRole, LoanNoteContactType, LoanNotePin, LoanNoteTopic } from '../loan/LoanNotes';
import { zodBrandedUuid, zodDateOrString } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

const BaseLoanNoteInput = z.object({
  id: zodBrandedUuid<LoanNoteId>().optional(),
  comment: z.string(),
  topics: z.array(LoanNoteTopic).optional(),
  contactType: LoanNoteContactType.optional(),
  contactRole: LoanNoteContactRole.optional(),
  borrowerId: zodBrandedUuid<BorrowerId>().optional(),
});

export const AddLoanNoteEvent = BaseLoanEvent.extend({
  type: z.literal('addLoanNote'),
  comment: z.string().optional(),
  input: z.discriminatedUnion('isBulkOperation', [
    z.object({ isBulkOperation: z.literal(false), note: BaseLoanNoteInput }),
    z.object({
      isBulkOperation: z.literal(true),
      notes: z.array(
        BaseLoanNoteInput.extend({
          author: z.discriminatedUnion('type', [
            z.object({ type: z.literal('userId'), id: zodBrandedUuid<UserId>() }),
            z.object({ type: z.literal('name'), name: z.string() }),
          ]),
          pin: LoanNotePin.optional(),
          timestamp: zodDateOrString.optional(),
        }),
      ),
    }),
  ]),
});
export type AddLoanNoteEvent = z.infer<typeof AddLoanNoteEvent>;
